<dx-modal
  (modalClosed)="modalClosed($event)"
  [label]="title || titleText()"
  [visible]="true"
  [width]="width"
  height="content"
>
  <div slot="content">
    <ng-content></ng-content>
  </div>

  @for (button of buttons; track button) {
    <spa-button
      (clickedButton)="button.action($event)"
      [disabled]="button.disabled ? (button.disabled | async) : false"
      [label]="button.label"
      [slot]="button.primary ? 'primary-actions' : 'secondary-actions'"
      [shape]="button.primary ? 'primary' : 'link'"
      [attr.data-testid]="button.dataTestID"
    ></spa-button>
  }
</dx-modal>
